<template>
    <div class="content is-large">
        <h1>Lightbulb Education Code</h1>
        <p><b>Lightbulb Education Code offers high-quality step by step project focused coding tutorials.</b> These are
            designed for
            skill levels from absolute beginner to intermediate level. Tutorials are also organized into courses,
            so that students can build up their skills by making progressively more challenging projects with a common
            toolset.
        </p>
        <a target="_blank" class="button is-primary is-large" href="https://code.lightbulb.education">See Lightbulb
            Education Code</a>
        <h2>Background</h2>
        <p>Lightbulb Education is a student led educational services company founded by Adam Nguyen and Jonathan Chacko,
            creating a variety of solutions for implementing technology within the classroom.
        </p>
        <a target="_blank" href="https://lightbulb.education" class="button is-large">See Lightbulb Education</a>
    </div>

</template>

<script>
    export default {
        name: "LightbulbEduCode"
    }
</script>

<style scoped>

</style>